import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const AthleteProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const AthleteProfileDangerButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-rose-600 px-4 py-3 text-sm font-medium text-white transition hover:bg-rose-700 sm:w-auto",
})``;

export const AthleteProfileSectionActionButton = styled.button.attrs({
  className:
    "inline-flex min-h-[40px] items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-2 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] disabled:cursor-not-allowed disabled:opacity-45",
})``;

export const AthleteProfileGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const AthleteProfileGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.85fr_1.15fr]",
})``;

export const AthleteProfileContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const AthleteProfileHeroImage = styled(FallbackImage).attrs({
  className: "mx-auto h-32 w-32 max-w-full rounded-[22px] sm:h-44 sm:w-44 sm:rounded-[24px]",
})``;

export const AthleteProfileOverviewLayout = styled.div.attrs({
  className: "space-y-5",
})``;

export const AthleteProfileIdentityRow = styled.div.attrs({
  className: "flex items-center gap-4",
})``;

export const AthleteProfileOverviewDetails = styled.div.attrs({
  className: "min-w-0 flex-1 space-y-1",
})``;

export const AthleteProfileIdentityName = styled.h3.attrs({
  className: "text-xl font-semibold text-[var(--brand-ink)] sm:text-2xl",
})``;

export const AthleteProfileIdentityRole = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const AthleteProfileBioText = styled.p.attrs({
  className: "text-sm leading-7 text-[var(--brand-ink)] sm:text-[15px] sm:leading-7",
})``;

export const AthleteProfileOverviewRow = styled.div.attrs({
  className:
    "flex items-start justify-between gap-4 border-b border-[var(--brand-border)] py-2.5 last:border-b-0 last:pb-0",
})``;

export const AthleteProfileOverviewLabel = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.16em] text-[var(--brand-muted)]",
})``;

export const AthleteProfileOverviewValue = styled.div.attrs({
  className: "max-w-[62%] text-right text-sm font-medium leading-6 text-[var(--brand-ink)]",
})``;

export const AthleteProfileTeamsList = styled.div.attrs({
  className: "flex flex-col items-end gap-2",
})``;

export const AthleteProfileTeamButton = styled.button.attrs({
  className:
    "inline-flex max-w-full items-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-2 text-right transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const AthleteProfileTeamText = styled.div.attrs({
  className: "min-w-0",
})``;

export const AthleteProfileTeamName = styled.p.attrs({
  className: "truncate text-sm font-medium text-[var(--brand-ink)]",
})``;

export const AthleteProfileTeamMeta = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const AthleteProfileGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const AthleteProfileSection = styled.div.attrs({
  className: "brand-panel-muted md:col-span-2",
})``;

export const AthleteProfileEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const AthleteProfileBodyText = styled.p.attrs({
  className: "mt-3 text-sm leading-7 text-[var(--brand-ink)]",
})``;

export const AthleteProfileSectionSecondary = styled.div.attrs({
  className: "brand-panel-muted",
})``;

export const AthleteProfileTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const AthleteProfileContentStackSecondary = styled.div.attrs({ className: "space-y-6" })``;

export const AthleteProfileGridLayoutQuaternary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-2",
})``;

export const AthleteProfileSectionTertiary = styled.div.attrs({ className: "mt-8" })``;

export const AthleteProfileMetaText = styled.p.attrs({
  className: "mt-8 text-sm text-[var(--brand-muted)]",
})``;
